import React from 'react';
import { SlideContainer } from '../SlideContainer';
import { FadeInStagger, FadeIn } from '../FadeIn';
export const Slide03HowItWorks = () => {
  return <SlideContainer data-id="element-49">
      <FadeInStagger data-id="element-50">
        <FadeIn data-id="element-51">
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight text-white mb-16" data-id="element-52">
            Three agents, two modes, one pipeline
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16" data-id="element-53">
          <FadeIn data-id="element-54">
            <div className="bg-card border border-white/5 p-8 rounded-2xl h-full flex flex-col" data-id="element-55">
              <div className="text-accent-purple font-mono text-sm mb-4" data-id="element-56">
                01
              </div>
              <h3 className="text-xl font-semibold text-white mb-4" data-id="element-57">Planner</h3>
              <p className="text-white/60 leading-relaxed" data-id="element-58">
                Takes your training material, learning objectives, and rubric to
                create a structured conversation plan.
              </p>
            </div>
          </FadeIn>

          <FadeIn data-id="element-59">
            <div className="bg-card border border-white/5 p-8 rounded-2xl h-full flex flex-col" data-id="element-60">
              <div className="text-accent-purple font-mono text-sm mb-4" data-id="element-61">
                02
              </div>
              <h3 className="text-xl font-semibold text-white mb-4" data-id="element-62">
                Conductor
              </h3>
              <p className="text-white/60 leading-relaxed" data-id="element-63">
                Runs the live voice conversation with the learner. Adaptive,
                realistic, challenging. This is who the student actually talks
                to.
              </p>
            </div>
          </FadeIn>

          <FadeIn data-id="element-64">
            <div className="bg-card border border-white/5 p-8 rounded-2xl h-full flex flex-col" data-id="element-65">
              <div className="text-accent-purple font-mono text-sm mb-4" data-id="element-66">
                03
              </div>
              <h3 className="text-xl font-semibold text-white mb-4" data-id="element-67">
                Evaluator
              </h3>
              <p className="text-white/60 leading-relaxed" data-id="element-68">
                After the conversation, evaluates performance against your
                criteria. Produces scores, qualitative feedback, strengths, and
                areas for improvement.
              </p>
            </div>
          </FadeIn>
        </div>

        <FadeIn data-id="element-69">
          <div className="h-px w-full bg-white/10 mb-16" data-id="element-70"></div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-16" data-id="element-71">
          <FadeIn data-id="element-72">
            <div data-id="element-73">
              <h4 className="text-lg font-semibold text-white mb-2" data-id="element-74">
                Assessment Mode
              </h4>
              <p className="text-white/60 leading-relaxed" data-id="element-75">
                Professors use it to evaluate readiness and comprehension.
                Structured scoring, reports, cohort analytics.
              </p>
            </div>
          </FadeIn>

          <FadeIn data-id="element-76">
            <div data-id="element-77">
              <h4 className="text-lg font-semibold text-white mb-2" data-id="element-78">
                Practice Mode
              </h4>
              <p className="text-white/60 leading-relaxed" data-id="element-79">
                Students take it as many times as they like. Coaching feedback
                after every attempt.
              </p>
            </div>
          </FadeIn>
        </div>

        <FadeIn data-id="element-80">
          <div className="inline-block bg-white/5 border border-white/10 px-6 py-4 rounded-xl" data-id="element-81">
            <p className="text-white/80 font-medium" data-id="element-82">
              5 to 10 minute structured voice conversations. We design the
              exercises, maintain them, and own the full pipeline.
            </p>
          </div>
        </FadeIn>
      </FadeInStagger>
    </SlideContainer>;
};